import {
  getValidRedirectionUrl,
  setScreenUrlToLoacalStorage,
} from '../utils/constants/route';
import { BaseProps } from '../utils/types';
import { Navigate } from 'react-router-dom';

export const RoleBaseNavigation = ({
  authUser,
}: BaseProps) => {
  if (authUser?.actorName) {
    const validRedirectionUrl = getValidRedirectionUrl();
    return <Navigate to={validRedirectionUrl} replace />;
  } else {
    setScreenUrlToLoacalStorage();
    return <Navigate to="/sign-in" replace />;
  }
};
